import { Controller } from "stimulus";

// Rewrites a server-rendered start time into the browser's timezone. Mirrors
// LivePagesHelper#live_event_start_time ("Oct 9, 2026 - 3:00pm EDT") so the first paint and the
// rewrite agree. The server text stays as the no-JS fallback; an unparseable `datetime` leaves it alone.
const FORMAT = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  hour12: true,
  minute: "2-digit",
  timeZoneName: "short",
});

export default class extends Controller {
  connect() {
    const time = Date.parse(this.element.dateTime);
    if (Number.isNaN(time)) return;

    const parts = Object.fromEntries(FORMAT.formatToParts(new Date(time)).map((p) => [p.type, p.value]));
    this.element.textContent = `${parts.month} ${parts.day}, ${parts.year} - ${parts.hour}:${parts.minute}${parts.dayPeriod.toLowerCase()} ${parts.timeZoneName}`;
  }
}
